import { CognitoUserPool } from "amazon-cognito-identity-js";

const poolData = {
    UserPoolId: "us-west-1_eUwejdZI7",
    ClientId: "35g538050prir2st6d6een30up"
}

export default new CognitoUserPool(poolData);